var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60162 0.224609C2.15391 0.224609 2.60162 0.672325 2.60162 1.22461V28.2246H29.6016C30.1539 28.2246 30.6016 28.6723 30.6016 29.2246C30.6016 29.7769 30.1539 30.2246 29.6016 30.2246H2.60162C2.07119 30.2246 1.56248 30.0139 1.18741 29.6388C0.812337 29.2638 0.601624 28.755 0.601624 28.2246V1.22461C0.601624 0.672325 1.04934 0.224609 1.60162 0.224609Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85162 14.2246C6.71355 14.2246 6.60162 14.3365 6.60162 14.4746V23.9746C6.60162 24.1127 6.71355 24.2246 6.85162 24.2246H9.35162C9.48969 24.2246 9.60162 24.1127 9.60162 23.9746V14.4746C9.60162 14.3365 9.48969 14.2246 9.35162 14.2246H6.85162ZM4.60162 14.4746C4.60162 13.232 5.60898 12.2246 6.85162 12.2246H9.35162C10.5943 12.2246 11.6016 13.232 11.6016 14.4746V23.9746C11.6016 25.2172 10.5943 26.2246 9.35162 26.2246H6.85162C5.60898 26.2246 4.60162 25.2172 4.60162 23.9746V14.4746Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8516 11.2246C15.7136 11.2246 15.6016 11.3365 15.6016 11.4746V23.9746C15.6016 24.1127 15.7136 24.2246 15.8516 24.2246H18.3516C18.4897 24.2246 18.6016 24.1127 18.6016 23.9746V11.4746C18.6016 11.3365 18.4897 11.2246 18.3516 11.2246H15.8516ZM13.6016 11.4746C13.6016 10.232 14.609 9.22461 15.8516 9.22461H18.3516C19.5943 9.22461 20.6016 10.232 20.6016 11.4746V23.9746C20.6016 25.2172 19.5943 26.2246 18.3516 26.2246H15.8516C14.609 26.2246 13.6016 25.2172 13.6016 23.9746V11.4746Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8291 7.22461C24.691 7.22461 24.5791 7.33654 24.5791 7.47461V23.9746C24.5791 24.1127 24.691 24.2246 24.8291 24.2246H27.3291C27.4672 24.2246 27.5791 24.1127 27.5791 23.9746V7.47461C27.5791 7.33654 27.4672 7.22461 27.3291 7.22461H24.8291ZM22.5791 7.47461C22.5791 6.23197 23.5865 5.22461 24.8291 5.22461H27.3291C28.5717 5.22461 29.5791 6.23197 29.5791 7.47461V23.9746C29.5791 25.2173 28.5717 26.2246 27.3291 26.2246H24.8291C23.5865 26.2246 22.5791 25.2173 22.5791 23.9746V7.47461Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.62c9ad5dd6230e4a6d196c921f3da6d5.svg";
export { ForwardRef as ReactComponent };